var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2008_241)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M18.305 0.694946C13.8622 4.91407 7.9453 7.22814 1.81889 7.14264C1.03959 9.51682 0.643498 12 0.645515 14.4988C0.645515 25.4713 8.14885 34.6895 18.305 37.3051C28.4612 34.6915 35.9646 25.4732 35.9646 14.5008C35.9646 11.9303 35.5525 9.45604 34.7912 7.14068H34.493C28.2219 7.14068 22.5237 4.69189 18.305 0.694946Z",
    fill: "#1A56DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4189 19.8261L16.8338 24.241L24.192 13.9396",
    stroke: "#1A56DB",
    strokeWidth: 3.05085,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2008_241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.6102,
    height: 36.6102,
    fill: "white",
    transform: "translate(0 0.694946)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f47fd156a62464a60ac7d0c2cd30ffb9.svg";
export { ForwardRef as ReactComponent };